module.exports = __webpack_public_path__ + "assets/star-on-362aa9.svg";